export const BUILD_NUMBER = '17';
